export const SELECTED_DECEASED = '[DECEASED] SELECTED'
export const POPUP_PROPS = '[POPUP] POPUP_PROPS'
export const SET_WEEK = '[HEADER] SET WEEK'
export const SET_SHOW_MESSAGE = '[HEADER] SET SHOW MESSAGE'
export const SET_OPEN_MESSAGE = '[HEADER] SET OPEN MESSAGE'
export const SET_SHOW_MESSAGE_NOTIF = '[HEADER] SET SHOW MESSAGE NOTIF'
export const SET_NOTIFICATION_COUNT = '[NOTIFICATION] SET TOTAL MESSAGE'
export const SET_AGENDA_TAB = '[MENU] SET AGENDA TAB'
